import { useState, useEffect, forwardRef } from "react";
import CreatableSelect from 'react-select/creatable';
import Fetch from '../../../../../util/core/Fetch';

const MultiSelectCreatable = forwardRef((props, ref) => {
  const defaultValues = props.value && props.value.map((value) => ({ label: `${value}`, value }));
  const [value, setValue] = useState(defaultValues || []);
  const [options, updateOptions] = useState(props.options);
  const [error, updateError] = useState(props.error);
  let className = '';
  let customStyle = {};

  const loadOptions = async () => {
    if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
      let url = props.optionsEndpoint.endpoint;
      let keyLabel = props.optionsEndpoint.label;
      let keyValue = props.optionsEndpoint.value;
      const params = props.optionsEndpoint.params ? props.optionsEndpoint.params : {};
      let rows = await Fetch.post(url, params);

      const tempOptions = rows.map(item => ({
        value: item[keyValue],
        label: item[keyLabel]
      }));
      updateOptions(tempOptions);
    }
  };
  
  useEffect(() => {
    loadOptions();
  }, []);

  const handleChange = selectedOptions => {
    setValue(selectedOptions);
    const target = {
      name: props.name,
      type: 'multiselect',
      value: selectedOptions.map(option => option.value)
    };
    props.onChange({ target: target });
  };

  if (props.error) {
    className = "is-invalid";
    customStyle = { border: '1px solid #dc3545' };
  }

  return (
    <div  ref={ref}>
      <div style={customStyle}>
          <CreatableSelect
            value={value}
            autoFocus={props.autoFocus ? true : false}
            isClearable={props.value !== null}
            name={props.name}
            placeholder={props.placeholder ? props.placeholder : 'Selecione'}
            options={options}
            onChange={handleChange}
            isDisabled={props.disabled}
            isMulti
          />
      </div>
      {props.error && (
        <span
          className="error invalid-feedback"
          style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}
    </div>
  );
})

export default MultiSelectCreatable;